import React, { Component } from "react";
import { Container, Carousel, Row, Col, Modal } from "react-bootstrap";
import { FaStream, FaTree, FaRegHospital, FaSchool, FaSwimmingPool, FaHome, FaRulerCombined } from "react-icons/fa";
import { GiHomeGarage } from "react-icons/gi";
import { MdLocalMall, MdTrain, MdSchool, MdLocalGroceryStore } from "react-icons/md";
import { IoIosRestaurant } from "react-icons/io";
import ReqInfoForm from "../../components/ReqInfoForm";
import parse from "html-react-parser";
import fetchJsonWithFallback from "../../utils/fetchJsonWithFallback";
import { CDN_INCLUDES, propertyPhotoUrl } from "../../utils/cdn";
import localProperties from "../../data/properties.json";
import localContent from "../../data/propertyDetails.json";
import "./index.css";

const BedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 35 35" fill="none">
    <g clipPath="url(#clip_bed)">
      <path d="M3.92773 21.9179V9.98596C3.92773 8.18533 5.38126 6.73181 7.18189 6.73181H26.7068C28.5074 6.73181 29.961 8.18533 29.961 9.98596V21.9179" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
      <path d="M1.75854 21.9179H32.1306V27.3415C32.1306 28.5347 31.1544 29.5109 29.9612 29.5109H3.92798C2.73479 29.5109 1.75854 28.5347 1.75854 27.3415V21.9179Z" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.4358 17.579C12.233 17.579 13.6899 16.1221 13.6899 14.3249C13.6899 12.5277 12.233 11.0707 10.4358 11.0707C8.63857 11.0707 7.18164 12.5277 7.18164 14.3249C7.18164 16.1221 8.63857 17.579 10.4358 17.579Z" stroke="var(--color-text-dark)" strokeWidth="2.82027"/>
    </g>
    <defs><clipPath id="clip_bed"><rect width="34.711" height="34.711" fill="white"/></clipPath></defs>
  </svg>
);

const BathIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 35 35" fill="none">
    <g clipPath="url(#clip_bath)">
      <path d="M3.594 17.8026H29.6272C30.8204 17.8026 31.7967 18.7788 31.7967 19.972V22.1414C31.7967 25.7427 28.8896 28.6497 25.2883 28.6497H7.93287C4.3316 28.6497 1.42456 25.7427 1.42456 22.1414V19.972C1.42456 18.7788 2.40081 17.8026 3.594 17.8026Z" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.76392 17.8025V8.04004C5.76392 6.23941 7.21744 4.78589 9.01807 4.78589C10.8187 4.78589 12.2722 6.23941 12.2722 8.04004V9.12476" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
      <path d="M7.93237 28.6497L6.84766 32.9886" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
      <path d="M25.2881 28.6497L26.3728 32.9886" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
    </g>
    <defs><clipPath id="clip_bath"><rect width="34.711" height="34.711" fill="white"/></clipPath></defs>
  </svg>
);

const AreaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 35 35" fill="none">
    <path d="M30.3728 4.33893H4.3396V30.3721H30.3728V4.33893Z" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="4.34 4.34"/>
    <path d="M10.8486 30.3722V26.0333" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
    <path d="M17.3562 30.3721V26.0332" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
    <path d="M23.8652 30.3722V26.0333" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
    <path d="M30.3721 10.8472H26.0332" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
    <path d="M30.3721 17.3555H26.0332" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
    <path d="M30.3721 23.8638H26.0332" stroke="var(--color-text-dark)" strokeWidth="2.82027" strokeLinecap="round"/>
  </svg>
);

const HomeTypeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 38 38" fill="none">
    <path d="M28.2207 37.6888H9.47544C6.96322 37.6861 4.55466 36.6869 2.77825 34.9105C1.00184 33.1341 0.00267603 30.7255 0 28.2133V16.0287C0.000813104 14.5054 0.368555 13.0047 1.07211 11.6537C1.77566 10.3026 2.79432 9.14083 4.04188 8.26675L13.4149 1.70608C15.0091 0.595423 16.9055 0 18.8485 0C20.7915 0 22.6879 0.595423 24.2821 1.70608L33.6548 8.26709C34.9022 9.14119 35.9207 10.3029 36.6242 11.6539C37.3277 13.0049 37.6953 14.5055 37.6961 16.0287V28.2133C37.6935 30.7255 36.6943 33.1341 34.9179 34.9105C33.1415 36.6869 30.7329 37.6861 28.2207 37.6888ZM18.8481 3.42365C17.6077 3.42207 16.3969 3.80244 15.3802 4.51307L6.00637 11.0741C5.21009 11.6321 4.55995 12.3736 4.11096 13.2361C3.66197 14.0985 3.42734 15.0564 3.42692 16.0287V28.2133C3.42865 29.817 4.06645 31.3544 5.2004 32.4884C6.33434 33.6223 7.8718 34.2601 9.47544 34.2618H28.2207C29.8243 34.2601 31.3618 33.6223 32.4958 32.4884C33.6297 31.3544 34.2675 29.817 34.2692 28.2133V16.0287C34.2688 15.0564 34.0342 14.0985 33.5852 13.2361C33.1362 12.3736 32.4861 11.6321 31.6898 11.0741L22.3171 4.51307C21.3 3.80248 20.0888 3.42213 18.8481 3.42365Z" fill="var(--color-text-dark)"/>
    <path d="M23.9886 30.8349H13.7078C13.2534 30.8349 12.8176 30.6544 12.4962 30.3331C12.1749 30.0118 11.9944 29.5759 11.9944 29.1215V23.9811C11.9944 22.1634 12.7165 20.42 14.0018 19.1347C15.2872 17.8494 17.0305 17.1273 18.8482 17.1273C20.666 17.1273 22.4093 17.8494 23.6946 19.1347C24.98 20.42 25.7021 22.1634 25.7021 23.9811V29.1215C25.7021 29.5759 25.5216 30.0118 25.2002 30.3331C24.8789 30.6544 24.4431 30.8349 23.9886 30.8349ZM15.4213 27.408H22.2752V23.9811C22.2752 23.0722 21.9141 22.2006 21.2714 21.5579C20.6288 20.9152 19.7571 20.5542 18.8482 20.5542C17.9394 20.5542 17.0677 20.9152 16.425 21.5579C15.7824 22.2006 15.4213 23.0722 15.4213 23.9811V27.408Z" fill="var(--color-text-dark)"/>
  </svg>
);

const StatDivider = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1" height="52" viewBox="0 0 1 52" fill="none">
    <path d="M0.5 0V51.5" stroke="#FF4103"/>
  </svg>
);

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
});

class PropertyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            propertyData: [],
            showGallery: false,
            content: localContent
        };
    }

    componentDidMount() {
        fetchJsonWithFallback(CDN_INCLUDES + "properties.json", localProperties)
            .then((result) => {
                this.setState({
                    isLoaded: true,
                    propertyData: result
                });
            });

        fetchJsonWithFallback(CDN_INCLUDES + "propertyDetails.json", localContent)
            .then((content) => {
                this.setState({ content });
            });
    }

    render() {
        const setCloseGallery = () => {
            this.setState({ showGallery: false })
        }
        const setShowGallery = () => {
            this.setState({ showGallery: true })
        }
        const { propertyData, content } = this.state;
        const {
            match: {
                params: { PropertyId }
            }
        } = this.props;
        let propertyAvailable = true;
        const wholeInfo = propertyData.map(Properties => {
            let propId = Properties.prop_id;
            if ((String(propId) !== decodeURIComponent(PropertyId)) || (Properties.prop_visible === 0)) {
                return null;
            }
            propertyAvailable = false;
            let address = (Properties.prop_location.address === "" ? "" : Properties.prop_location.address) +
                (Properties.prop_location.city === "" ? "" : ", " + Properties.prop_location.city) +
                (Properties.prop_location.state === "" ? "" : ", " + Properties.prop_location.state) +
                (Properties.prop_location.zipcode === "" ? "" : " " + Properties.prop_location.zipcode);
            const previewPhotos = Properties.prop_listOfPhotos.slice(0, 2);
            const totalPhotos = 1 + Properties.prop_listOfPhotos.length;
            const a = Properties.prop_amenities;
            const statCount = [a.bedroom !== "", a.bathroom !== "", a.area !== "" && a.area !== undefined, Properties.prop_name !== "" && Properties.prop_name !== undefined, Boolean(a.swimmingPool), Boolean(a.garage), Boolean(a.park), Boolean(a.groceryStore), Boolean(a.malls), Boolean(a.restaurants), Boolean(a.hospital), Boolean(a.school), Boolean(a.highSchool), Boolean(a.trainStation), Boolean(a.other)].filter(Boolean).length;
            return <div className="property-detail" key={Properties.prop_id}>
                {/* Title head of Property Description page */}
                <div className="property-detail__header">
                    <div className="property-detail__intro">
                        <p className="property-detail__price">
                            {formatter.format(Properties.prop_rent)} <span>/ month</span>
                        </p>
                        <p className="property-detail__address">{parse(address)}</p>
                    </div>
                    <a
                        href={Properties.applyNowUrl || "#request-info"}
                        className="property-detail__cta"
                        {...(Properties.applyNowUrl ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >Apply Now</a>
                </div>

                {/* Photo gallery of Property Description page */}
                <div className="property-detail__gallery">
                    {/* Desktop: collage */}
                    <div className="property-detail__gallery-desktop">
                        <Row className="g-0">
                            <Col md={8} className="property-detail__gallery-col">
                                <button type="button" className="property-detail__gallery-main" onClick={() => setShowGallery(true)}>
                                    <img src={propertyPhotoUrl(Properties.prop_titlePhoto)} alt={address} />
                                </button>
                            </Col>
                            <Col md={4} className="property-detail__gallery-col property-detail__gallery-thumbs">
                                {previewPhotos.map((item, key) =>
                                    <button
                                        type="button"
                                        key={key}
                                        className={"property-detail__gallery-thumb" + (key === previewPhotos.length - 1 ? " property-detail__gallery-thumb--last" : "")}
                                        onClick={() => setShowGallery(true)}
                                    >
                                        <img src={propertyPhotoUrl(item)} alt={address} />
                                        {key === previewPhotos.length - 1 &&
                                            <span className="property-detail__gallery-overlay">See all {totalPhotos} photos</span>
                                        }
                                    </button>
                                )}
                            </Col>
                        </Row>
                    </div>
                    {/* Mobile: swipeable carousel */}
                    <div className="property-detail__gallery-mobile">
                        <Carousel interval={null} touch={true} indicators={true} controls={true} className="property-detail__mobile-carousel">
                            <Carousel.Item onClick={() => setShowGallery(true)}>
                                <img className="d-block w-100" src={propertyPhotoUrl(Properties.prop_titlePhoto)} alt={address} />
                            </Carousel.Item>
                            {Properties.prop_listOfPhotos.map((item, key) =>
                                <Carousel.Item key={key} onClick={() => setShowGallery(true)}>
                                    <img className="d-block w-100" src={propertyPhotoUrl(item)} alt={address} />
                                </Carousel.Item>
                            )}
                        </Carousel>
                        <p className="property-detail__mobile-carousel-hint">Tap image to view all {totalPhotos} photos</p>
                    </div>
                </div>

                {/* Key stats + Map of Property Description page */}
                <Row className="property-detail__content-row">
                    <Col md={8} className="property-detail__content-main">
                        <div className={"property-detail__stats" + (statCount <= 4 ? " property-detail__stats--few" : "")}>
                            {Properties.prop_amenities.bedroom !== "" &&
                                <div className="property-detail__stat">
                                    <BedIcon />
                                    <div className="property-detail__stat-text">
                                        <span className="property-detail__stat-value">{parse(String(Properties.prop_amenities.bedroom))}</span>
                                        <span className="property-detail__stat-label">Beds</span>
                                    </div>
                                </div>
                            }
                            {Properties.prop_amenities.bathroom !== "" &&
                                <><StatDivider />
                                <div className="property-detail__stat">
                                    <BathIcon />
                                    <div className="property-detail__stat-text">
                                        <span className="property-detail__stat-value">{parse(String(Properties.prop_amenities.bathroom))}</span>
                                        <span className="property-detail__stat-label">Baths</span>
                                    </div>
                                </div></>
                            }
                            {Properties.prop_amenities.area !== "" && Properties.prop_amenities.area !== undefined &&
                                <><StatDivider />
                                <div className="property-detail__stat">
                                    <AreaIcon />
                                    <div className="property-detail__stat-text">
                                        <span className="property-detail__stat-value">{parse(String(Properties.prop_amenities.area))}</span>
                                        <span className="property-detail__stat-label">Sq. ft.</span>
                                    </div>
                                </div></>
                            }
                            {Properties.prop_name !== "" && Properties.prop_name !== undefined &&
                                <><StatDivider />
                                <div className="property-detail__stat property-detail__stat--type">
                                    <HomeTypeIcon />
                                    <div className="property-detail__stat-text">
                                        <span className="property-detail__stat-label">{parse(Properties.prop_name)}</span>
                                    </div>
                                </div></>
                            }
                            {Boolean(Properties.prop_amenities.swimmingPool) && <><StatDivider /><div className="property-detail__stat"><FaSwimmingPool className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">Pool</span></div></div></>}
                            {Boolean(Properties.prop_amenities.garage) && <><StatDivider /><div className="property-detail__stat"><GiHomeGarage className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-value">{parse(String(Properties.prop_amenities.garage))}</span><span className="property-detail__stat-label">Car Garage</span></div></div></>}
                            {Boolean(Properties.prop_amenities.park) && <><StatDivider /><div className="property-detail__stat"><FaTree className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">Park</span></div></div></>}
                            {Boolean(Properties.prop_amenities.groceryStore) && <><StatDivider /><div className="property-detail__stat"><MdLocalGroceryStore className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">Grocery</span></div></div></>}
                            {Boolean(Properties.prop_amenities.malls) && <><StatDivider /><div className="property-detail__stat"><MdLocalMall className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">Mall</span></div></div></>}
                            {Boolean(Properties.prop_amenities.restaurants) && <><StatDivider /><div className="property-detail__stat"><IoIosRestaurant className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">Restaurants</span></div></div></>}
                            {Boolean(Properties.prop_amenities.hospital) && <><StatDivider /><div className="property-detail__stat"><FaRegHospital className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">Hospital</span></div></div></>}
                            {Boolean(Properties.prop_amenities.school) && <><StatDivider /><div className="property-detail__stat"><FaSchool className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">School</span></div></div></>}
                            {Boolean(Properties.prop_amenities.highSchool) && <><StatDivider /><div className="property-detail__stat"><MdSchool className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">High School</span></div></div></>}
                            {Boolean(Properties.prop_amenities.trainStation) && <><StatDivider /><div className="property-detail__stat"><MdTrain className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">Train</span></div></div></>}
                            {Boolean(Properties.prop_amenities.other) && <><StatDivider /><div className="property-detail__stat"><FaStream className="property-detail__stat-icon" /><div className="property-detail__stat-text"><span className="property-detail__stat-label">{parse(Properties.prop_amenities.other)}</span></div></div></>}
                        </div>

                        {/* {content.descriptionHeading &&
                            <h3 className="property-detail__section-title">{parse(content.descriptionHeading)}</h3>
                        } */}
                        <div className="property-detail__description">{parse(Properties.prop_descp)}</div>
                    </Col>
                    <Col md={4} className="property-detail__content-map">
                        {(() => {
                            const buildMapSrc = (url, addr) => {
                                if (url) return url;
                                return `https://www.google.com/maps?q=${encodeURIComponent(addr)}&output=embed&iwloc=`;
                            };
                            const mapSrc = buildMapSrc(Properties.prop_location.mapURL, address);
                            return (
                                <div className="property-detail__map">
                                    <iframe src={mapSrc} style={{ width: "100%", height: "100%", border: 0 }} title={Properties.prop_location.address} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                                </div>
                            );
                        })()}
                    </Col>
                </Row>

                {/* Amenities + Request Information of Property Description page */}
                {/* <Row className="property-detail__body" id="request-info">
                    <Col sm={8} className="property-detail__main">
                    </Col>
                    <ReqInfoForm propId={PropertyId} propInfo={propertyData} heading={content.requestInfoHeading} />
                </Row> */}

                {/* Modal to show property images */}
                <Modal show={this.state.showGallery} onHide={setCloseGallery} size="lg" className="property-detail__gallery-modal">
                    <Modal.Body>
                        <div style={{ position: 'relative' }}>
                            <button type="button" className="property-detail__gallery-close" onClick={() => setCloseGallery(false)} aria-label="Close">
                                &times;
                            </button>
                            <Carousel interval={null} touch={true} indicators={true} controls={false}>
                                <Carousel.Item>
                                    <img className="d-block w-100" src={propertyPhotoUrl(Properties.prop_titlePhoto)} alt={address} />
                                </Carousel.Item>
                                {Properties.prop_listOfPhotos.map((item, key) =>
                                    <Carousel.Item key={key}>
                                        <img className="d-block w-100" src={propertyPhotoUrl(item)} alt={address} />
                                    </Carousel.Item>)}
                            </Carousel>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        });
        if (!this.state.isLoaded) {
            return <Container className="property-detail-page">
                <Row>
                    <Col xs={12} className="property-detail__loading">
                        <div className="property-detail__spinner" />
                        <p>Loading property details&hellip;</p>
                    </Col>
                </Row>
            </Container>
        }

        if (propertyAvailable) {
            return <Container className="property-detail-page">
                <Row>
                    <Col xs={12} className="property-detail__unavailable">
                        <h3>{parse(content.unavailableMessage)}</h3>
                    </Col>
                </Row>
            </Container>
        }

        return <Container className="property-detail-page">
            <Row>
                <Col xs={12}>
                    {wholeInfo}
                </Col>
            </Row>
        </Container>
    }
}

export default PropertyDetails;
